import { connect } from 'react-redux'
import { receiveImports } from 'modules/imports/actions'
import { showTransientNotification } from '@driftt/traffic-control'

import ImportsHome from 'pages/ImportsHome'

const mapStateToProps = state => ({
  imports: state.imports
})

const mapDispatchToProps = dispatch => {
  return {
    onReceiveImports: imports => {
      dispatch(receiveImports(imports))
    },
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportsHome)
